import { useEffect, useMemo, useState } from "react";
import "./Catalog.css";
import { Filters, CallToAction, ProjectsGrid } from "./components";
import {
    getCategories as apiGetCategories,
    getProjects as apiGetProjects,
} from "../../services/apiService";
import { useLocation, useNavigate } from "react-router-dom";
import { Header } from "../../components";
import { useQuery } from "react-query";

const getProjects = async (selectedCategories) => {
    // console.log("GET PROJECTS WITH: ", selectedCategories);

    const res = await apiGetProjects(selectedCategories);
    return res.data;
};

const getCategories = async () => {
    const res = await apiGetCategories();
    return res.data;
};

const Catalog = () => {
    let { state } = useLocation();
    const [allIsActive, setAllIsActive] = useState(
        state?.selectedCategories ? false : true
    );
    // const [projects, setProjects] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState(
        state?.selectedCategories || []
    );
    const [searchInput, setSearchInput] = useState("");
    const navigate = useNavigate();

    const {
        data: categories = [],
        isLoading: isCategoriesLoading,
        error: categoriesError,
    } = useQuery(["categories"], getCategories);

    const {
        data: projects = [],
        isLoading: isProjectsLoading,
        error: projectsError,
    } = useQuery(["projects", selectedCategories], () =>
        getProjects(selectedCategories)
    );

    const filteredProjects = useMemo(() => {
        return projects.filter((project) =>
            project.project_title
                .toLowerCase()
                .includes(searchInput.toLocaleLowerCase())
        );
    }, [searchInput, projects]);

    const selectCategory = (category) => {
        if (isSelected(category)) {
            setSelectedCategories((prev) => prev.filter((e) => e !== category));
        } else {
            setSelectedCategories((prev) => [...prev, category]);
            setAllIsActive(false);
        }
    };
    useEffect(() => {
        if (selectedCategories.length === 0) {
            handleChangeAllFilter();
        }
    }, [selectedCategories]);

    const isSelected = (id) => {
        return selectedCategories.find((cat) => cat == id);
    };

    // console.log("SELECTED CATEGORIES: ", selectedCategories);
    // console.log("FETCHED CATEGORIES: ", fetchedCategories);

    const handleChangeAllFilter = () => {
        // console.log("HI ALL");

        if (allIsActive == false) {
            setAllIsActive(true);
            setSelectedCategories([]);
        } else {
            return;
        }
    };

    // console.log("PROJECTS: ", projects);
    // console.log("SEARCH INPUT: ", searchInput);

    // console.log("SELECTED CATEGORIES: ", selectedCategories);

    return (
        <div className="catalog">
            <Header
                CallToAction={<CallToAction />}
                title={"Projects"}
                GoBackClick={() => navigate("/")}
            />
            <p className="description">
                Filter by selecting one or more project types below, or by using the search bar to find a specific project
            </p>
            <div className="catalog-header">
                <input
                    type="text"
                    name=""
                    placeholder="Search"
                    className="search-input"
                    onChange={(e) => setSearchInput(e.target.value)}
                />
            </div>
            <Filters
                categories={categories}
                isLoading={isCategoriesLoading}
                error={categoriesError}
                allIsActive={allIsActive}
                handleChangeAllFilter={handleChangeAllFilter}
                isSelected={isSelected}
                selectCategory={selectCategory}
            />
            <ProjectsGrid
                isLoading={isProjectsLoading}
                error={projectsError}
                filteredProjects={filteredProjects}
            />
        </div>
    );
};

export default Catalog;
